//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    data () {
        return {
            showNext: false,
            showHoverBg: false,
            samples: [],
            sampleOptions: {
                numSamples: 9,
                width: 156,
                height: 54
            },
            dropAreas: [
                {
                    xMin: 300,
                    xMax: 540,
                    yMin: 430,
                    yMax: 680
                },
                {
                    xMin: 580,
                    xMax: 820,
                    yMin: 430,
                    yMax: 680
                },
                {
                    xMin: 870,
                    xMax: 1100,
                    yMin: 430,
                    yMax: 680
                }
            ]
        };
    },

    computed: {
        result () {
            let numCorrect = this.dropAreas.filter((area, index) =>
                this.samples.filter(sample => sample.dropAreaIndex === index).length === 3
            ).length;

            return this.$game.getDragDropResult(numCorrect * 3, (this.dropAreas.length - numCorrect) * 3);
        }
    },

    created () {
        for (let index = 0; index < this.sampleOptions.numSamples; index++) {
            this.samples.push({
                x: 70 + (Math.random() * 25),
                y: 627 - (index * 56),
                dropAreaIndex: -1
            });
        }
    },

    methods: {
        dragend (sample, { x, y }) {
            this.showHoverBg = false;

            sample.x = x;
            sample.y = y;
            sample.dropAreaIndex = this.dropAreas.findIndex((area, index) =>
                sample.x >= area.xMin - this.sampleOptions.width / 2 &&
                sample.x <= area.xMax - this.sampleOptions.width / 2 &&
                sample.y >= area.yMin - this.sampleOptions.height / 2 &&
                sample.y <= area.yMax - this.sampleOptions.height / 2
            );

            if (sample.dropAreaIndex !== -1) {
                this.$nextTick(() => {
                    this.samples
                        .filter(sampleIt => sampleIt.dropAreaIndex === sample.dropAreaIndex)
                        .forEach((sampleIt, index) => {
                            sampleIt.x = this.dropAreas[sampleIt.dropAreaIndex].xMin + 37;
                            sampleIt.y = this.dropAreas[sampleIt.dropAreaIndex].yMax - 30 - (this.sampleOptions.height + 5) * (index + 1);
                        });
                });
            }
        }
    }
};
